<template>
  <span v-if="color" class="def-colors-small">
    <a
      v-for="item in color.items"
      :href="item.detailPage"
      :class="{ 'def-colors-small__item_active': item.active }"
      :style="`color: ${item.displayValue}`"
      class="def-colors-small__item"
    ></a>
  </span>
</template>

<script>
export default {
  name: 'DefColorsSmall',
  props: {
    result: {
      type: Object,
    },
  },
  computed: {
    color() {
      return this.result?.matrix?.COLOR_METALL;
    },
  },
};
</script>

<style lang="scss" scoped>
.def-colors-small {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 16px;
  justify-content: flex-start;
  padding: 3px;
  &__item {
    display: block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    position: relative;
    background-color: currentColor;
    &:before {
      content: '';
      position: absolute;
      top: -2px;
      right: -2px;
      bottom: -2px;
      left: -2px;
      border-radius: 50%;
      border: 1px solid #e0e0e0;
    }
    &_active {
      &:before {
        border-color: var(--background-black);
      }
    }
  }
}
</style>
